import { BottomSheet, Button, Flex } from 'components/InterUI/InterUI'
import useBoundState from 'store'

import { Text } from '@interco/inter-ui/components/Text'

import * as S from './Redemption.styles'

interface Props {
  handleCloseBottomSheet: () => void
}

export const RedemptionHelpBS = ({ handleCloseBottomSheet }: Props) => {
  const contentCapitalization = useBoundState((state) => state.contentCapitalization)

  return (
    <BottomSheet onClose={handleCloseBottomSheet}>
      <Flex gap="8px">
        <Text variant="headline-h3" as="h3" colorWeight={600} semiBold>
          Com o valor disponível, você pode:
        </Text>

        <S.ListWrapper>
          <S.ListItem>
            <Text variant="body-3" colorWeight={400}>
              Utilizar o valor como parte do pagamento para adquirir novas{' '}
              {contentCapitalization.value2} e continuar participando dos sorteios ao longo do ano;
            </Text>
          </S.ListItem>
          <S.ListItem>
            <Text variant="body-3" colorWeight={400}>
              Resgatar o valor diretamente para sua conta Inter;
            </Text>
          </S.ListItem>
          <S.ListItem>
            <Text variant="body-3" colorWeight={400}>
              Aguardar o depósito automático em sua conta, que será realizado até 15 dias após o
              término da vigência de cada {contentCapitalization.value1}.
            </Text>
          </S.ListItem>
        </S.ListWrapper>
        <Button variant="primary" onClick={handleCloseBottomSheet} fullWidth>
          Entendi
        </Button>
      </Flex>
    </BottomSheet>
  )
}
